var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"default-img-class",attrs:{"src":_vm.getResourcesByName(_vm.imgNameList[_vm.imgIndex])}})}
var staticRenderFns = []

export { render, staticRenderFns }